import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const WebsiteIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M10 0C6.74107 0 3.84869 1.57739 2.02148 4H2V4.02734C0.749953 5.69669 0 7.76039 0 10C0 15.511 4.489 20 10 20C15.511 20 20 15.511 20 10C20 4.489 15.511 0 10 0ZM13 2.58398C15.9351 3.76736 18 6.63265 18 10C18 12.0878 17.2006 13.9783 15.8984 15.4004C15.6426 14.5907 14.8946 14 14 14C13.448 14 13 13.552 13 13V11C13 10.448 12.552 10 12 10H8C7.448 10 7 9.552 7 9C7 8.448 7.448 8 8 8C8.552 8 9 7.552 9 7V6C9 5.448 9.448 5 10 5H11C12.105 5 13 4.105 13 3V2.58398ZM2.20703 8.20703L7 13V14C7 15.105 7.895 16 9 16V17.9316C5.04577 17.4412 2 14.0907 2 10C2 9.38219 2.07552 8.78403 2.20703 8.20703Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

WebsiteIcon.propTypes = {
  sx: PropTypes.object,
};

export default WebsiteIcon;
